/**
 * Clase que permite esperar un tiempo antes de volver a intentar una acción.
 * Se utiliza para evitar que se hagan demasiadas peticiones a la API en caso de que esta falle.
 * @param name Nombre del waiter
 * @param timeouts Array de tiempos de espera
 * @returns {ErrorWaiter}
 * @constructor Es un Abstract Factory de Singletons. Si se llama con el mismo nombre, devuelve el mismo objeto.
 * @example
 * const waiter = new ErrorWaiter('test', [1000, 2000, 3000]);
 */
export default class ErrorWaiter {
  static waiters = {};

  timeouts = [];
  isWaiting = false;
  tries = 0;
  cleaner = null;

  constructor(name, timeouts) {
    if (ErrorWaiter.waiters[name]) return ErrorWaiter.waiters[name];

    this.name = name;
    this.timeouts = timeouts;

    ErrorWaiter.waiters[name] = this;
    return this;
  }

  /**
   * Devuelve el tiempo de espera acorde a la cantidad de intentos
   */
  get timeout() {
    if (this.tries >= this.timeouts.length)
      return this.timeouts[this.timeouts.length - 1];

    return this.timeouts[this.tries];
  }

  /**
   * Devuelve true si esta esperando
   */
  get isWaiting() {
    return this.isWaiting;
  }

  /**
   * Suma un intento. Debe ser llamado mientras se esta esperando volver a intentar
   */
  try() {
    this.isWaiting = true;
    this.tries += 1;
    this.resetCleaner();
  }

  /**
   * Detiene la espera
   */
  stopWaiting() {
    this.isWaiting = false;
  }

  /**
   * Resetea los intentos
   */
  reset() {
    this.tries = 0;
  }

  /**
   * Resetea el setTimeout que reiniciaría los intentos
   */
  resetCleaner() {
    if (this.cleaner) clearTimeout(this.cleaner);

    this.cleaner = setTimeout(() => {
      this.reset();
      this.cleaner = null;
      ErrorWaiter.waiters[this.name] = null;
    }, this.timeouts[this.timeouts.length - 1] * 5);
  }
}
